export default __webpack_public_path__ + "9e3bfef30907e1178f702fe21938c628.png";